export { default } from "./Footer.js";
